module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('router-link', {
    attrs: {
      "to": "/cp/inicio",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Inicio")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/cp/chegadas",
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Chegadas")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d7f3554"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cp/Nav.vue
// module id = 261
// module chunks = 1